// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"195":"fa1bbee1","255":"290709e1","284":"d8ca8439","288":"6125db64","303":"614ae02a","661":"640436bd","732":"0788c4f3","875":"90d869e6"}[chunkId] + ".js";
};